import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _UnassignFacilityRequestDtoSchema = z.object({
  managerId: z.number(),
  facilityId: z.number(),
});

const UnassignFacilityResponseDtoSchema = z.string();

export type UnassignFacilityRequestDto = z.infer<
  typeof _UnassignFacilityRequestDtoSchema
>;
export type UnassignFacilityResponseDto = z.infer<
  typeof UnassignFacilityResponseDtoSchema
>;

export const unassignFacility = (
  params: UnassignFacilityRequestDto,
  config?: AxiosRequestConfig<UnassignFacilityRequestDto>
) => {
  return api
    .delete(
      `/managers/${params.managerId}/facilities/${params.facilityId}`,
      config
    )
    .then(responseContract(UnassignFacilityResponseDtoSchema));
};
